import moment from "moment";
import { formatShortDate } from "./periods";

const ISO = "YYYY-MM-DD";

/**
 * Izveštaji koji rade samo za jedan dan (Naručeno, Naručioci): kad se takav ekran otvori sa periodom dužim od dana,
 * period se sam prebacuje na jedan dan, umesto da korisnik gleda poruku "dostupan samo na dnevnom nivou". Dan je
 * danas ako je u periodu, inače poslednji dan perioda (period u budućnosti: prvi dan). Kad korisnik ode na ekran koji
 * prima period, vraća se raniji period, ali samo ako dan u međuvremenu nije menjao.
 *
 * Ljuska daje: `from`, `to`, računato `isDailyScreen`, `setDailyPeriod({ from, to })` i `showToast(text)`.
 * Dok ekran već traje, ručni izbor perioda se poštuje (ekran tada pokazuje svoju poruku).
 */
export default {
  watch: {
    isDailyScreen(daily) {
      if (!daily) {
        this.leaveDailyScreen();
        return;
      }
      const day = this.startDailyScreen(this.from, this.to);
      if (day) {
        this.setDailyPeriod({ from: day, to: day });
      }
    },
  },
  methods: {
    /** Dan koji se prikazuje za period; null ako je period već jedan dan. */
    pickDailyDay(from, to) {
      if (!from || !to || from === to) {
        return null;
      }
      const today = moment().format(ISO);
      if (from <= today && today <= to) {
        return today;
      }
      return to < today ? to : from;
    },
    /**
     * Pamti raniji period i javlja korisniku šta je izabrano; vraća dan na koji treba prebaciti period (ili null ako
     * prebacivanje nije potrebno). Poziva se i pri kreiranju ljuske, pre nego što se period iz adrese primeni.
     */
    startDailyScreen(from, to) {
      const day = this.pickDailyDay(from, to);
      if (!day) {
        return null;
      }
      this.dailyRestore = { from, to, day };
      this.$nextTick(() => {
        this.showToast(this.$t("report_desktop.daily_switched", { date: formatShortDate(day, true) }));
      });
      return day;
    },
    /** Izlaz sa dnevnog ekrana: vraća raniji period ako je izabrani dan ostao netaknut. */
    leaveDailyScreen() {
      const restore = this.dailyRestore;
      this.dailyRestore = null;
      if (restore && this.from === restore.day && this.to === restore.day) {
        this.setDailyPeriod({ from: restore.from, to: restore.to });
      }
    },
  },
};
